import styled from 'styled-components';
import { rem } from 'polished';
import mediaqueries from '../../../../config/themes/variables/mediaqueries';
import AvatarPerson from '../../../core/AvatarPerson';
import TitleWidget from '../../../core/TitleWidget';

const StyledAccessControl = styled.div`
  width: 100%;
`;

const StyledTitleWidget = styled(TitleWidget)`
  color: #000;
  line-height: ${rem('30px')};
  margin-bottom: ${rem('25px')};
  margin-left: ${rem('24px')};
  padding-left: ${rem('24px')};

  & > svg {
    left: ${rem('-23px')};
    bottom: 0;
  }
`;

const StyledSaveWarning = styled.div`
  display: flex;
  align-items: flex-start;
  gap: ${rem('12px')};
  max-width: ${rem('773px')};
  margin-bottom: ${rem('30px')};
  padding: ${rem('14px')} ${rem('18px')};
  background-color: #fff4e5;
  border: ${rem('1px')} solid #f5a623;
  border-left: ${rem('6px')} solid #e67e00;
  border-radius: ${rem('4px')};
  color: #5c3200;
  font-size: ${rem('15px')};
  line-height: ${rem('22px')};

  .save-warning-icon {
    flex-shrink: 0;
    font-size: ${rem('22px')};
    line-height: ${rem('22px')};
  }

  .save-warning-title {
    display: block;
    font-weight: 700;
    margin-bottom: ${rem('2px')};
  }
`;

const StyledFormControl = styled.div`
  margin-bottom: ${rem('50px')};
  .form-access {
    max-width: ${rem('773px')};
    overflow: auto;
  }
  .wrapper-time-flex {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  .time-row {
    display: flex;
    flex-direction: row;
    gap: 10px;
  }
  .time-input {
    flex: 1;
  }
  .time-input-only {
    /* Mismo ancho que un .time-input dentro de .time-row:
       dos hijos flex:1 con gap de 10px miden calc(50% - 5px) cada uno. */
    width: calc(50% - 5px);
  }
`;

const StyledTableControl = styled.div`
  width: 100%;
  overflow-x: scroll;
  ${mediaqueries.greaterThan('desktop')`
    overflow-x: scroll;
  `}
  .th-name {
    min-width: ${rem('112px')};
  }
  .th-date {
    min-width: ${rem('112px')};
  }
  .th-time {
    min-width: ${rem('115px')};
  }

  .th-observations {
    min-width: ${rem('385px')};
  }
`;

const StyledAvatarPerson = styled(AvatarPerson)`
  font-size: 100%;
  border: ${rem('2px')} ${props => props.theme.colors.dark} solid;
`;

const StyledSearchFormControl = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  margin-bottom: ${rem('35px')};

  .wrapper-box {
   // min-width: ${rem('400px')};
  }

  .wrapper-btn-send {
    display: flex;
    width: 100%;
    height: 100%;
    justify-content: flex-end;
    align-items: flex-end;
    padding-right: ${rem('14px')};

    ${mediaqueries.greaterThan('mobile')`
      width: auto;
    `}
  }
  .btn-send {
    height: ${rem('40px')};
    align-self: flex-end;
    ${mediaqueries.greaterThan('desktop')`
      margin-left: ${rem('20px')};
    `}
  }
`;

export {
  StyledAccessControl,
  StyledTitleWidget,
  StyledSaveWarning,
  StyledFormControl,
  StyledTableControl,
  StyledAvatarPerson,
  StyledSearchFormControl
};
